var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DemoStep",
    [
      _c("form", { staticClass: "d-flex gap-2" }, [
        _c("img", {
          staticClass: "persona-avatar flex-shrink-0",
          attrs: {
            src: _vm.$t(`demo.personas.${_vm.persona.id}.avatar`),
            alt: `Illustration of ${_vm.$t(
              `demo.personas.${_vm.persona.id}.name`
            )}`,
          },
        }),
        _c(
          "div",
          { staticClass: "full-width" },
          [
            _c(
              "h3",
              {
                staticClass: "text-h4 primary--text mb-2",
                attrs: { id: `persona-title-${_vm.persona.id}` },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t(`demo.personas.${_vm.persona.id}.name`)) +
                    " "
                ),
              ]
            ),
            _c("v-textarea", {
              attrs: {
                outlined: "",
                "hide-details": "",
                label: _vm.$t("demo.personas.prompt"),
                placeholder: _vm.$t(`demo.personas.${this.persona.id}.prompt`),
                "auto-grow": "",
              },
              model: {
                value: _vm.prompt,
                callback: function ($$v) {
                  _vm.prompt = $$v
                },
                expression: "prompt",
              },
            }),
          ],
          1
        ),
      ]),
      _c("DemoBtns", {
        attrs: { "should-lock": "" },
        on: { onBack: _vm.previousStep, onNext: _vm.next },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }